import { API_ENDPOINTS, API_ERROR_MESSAGES } from "../constants/api";
import { apiFetch } from "./apiClient";

export async function searchPilInfo({ searchType, phone, pilId, division }) {
  const payload =
    searchType === "phone"
      ? { search_type: "phone", phone }
      : { search_type: "pil_id", pil_id: pilId };

  if (division === "ROFF") {
    payload.pil_division = division;
  }

  const response = await apiFetch(API_ENDPOINTS.pilInfo.search, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.pilInfoReadFailed);
  }

  if (!response.ok || result.status !== "SUCCESS") {
    throw new Error(
      result?.message ||
        result?.lookup?.error ||
        API_ERROR_MESSAGES.pilInfoFetchFailed,
    );
  }

  return result;
}
